import type { NavigationLink } from '@hellodarwin/core/lib/features/entities';
import type { AccessLevel } from '@hellodarwin/core/lib/features/entities/pages-entities';
import File from '@hellodarwin/icons/dist/icons/File';
import User from '@hellodarwin/icons/dist/icons/User';

type Translate = (key: string) => string;

export const resolveHeaderUserMenuLinks = (
  accessLevel: AccessLevel,
  t: Translate,
): NavigationLink[] => [
  {
    label: t('navigation.settings'),
    pathname: '/profile/contact',
    Icon: User,
  },
  ...(accessLevel === 'custom'
    ? [
        {
          pathname: '/vault',
          Icon: File,
          label: t('vault|navigationTitle'),
        },
      ]
    : []),
];
